import { useCurrencyAmounts } from '@/hooks/business/useCurrencyAmounts'

interface SubscriptFormatResult {
  beforeZeros: string
  zeroCount: string
  afterZeros: string
  hasSubscript: boolean
  currencySymbol: string
}

export default function useFormatWithSubscript(
  price: number,
  tokenSymbol: string,
): SubscriptFormatResult {
  // Use useCurrencyAmounts to get converted price with currency symbol
  const {
    currency,
    amounts: [{ value: convertedPrice }],
  } = useCurrencyAmounts({
    amounts: [price],
    currencyFormatOptions: {},
    tokenSymbol,
  })

  const value = convertedPrice ?? 0
  const currencySymbol = currency?.symbol ?? ''

  // Use toFixed with enough decimals to avoid scientific notation
  // For very small numbers, we need more decimal places
  let str = value.toFixed(20)
  // Remove trailing zeros
  str = str.replace(/\.?0+$/, '')

  const match = str.match(/^0\.0{5,}/)

  if (match) {
    const zeroCount = match[0].length - 2 // subtract "0."
    const remainingStr = str.slice(match[0].length)
    // Get first 4 significant digits after the zeros
    const afterZeros = remainingStr.slice(0, 4)
    return {
      beforeZeros: `${currencySymbol}0.0`,
      zeroCount: String(zeroCount),
      afterZeros,
      hasSubscript: true,
      currencySymbol,
    }
  }

  return {
    beforeZeros: str,
    zeroCount: '',
    afterZeros: '',
    hasSubscript: false,
    currencySymbol,
  }
}
